import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
    isLoading: true,
    vehicleTypes: [],
    vehicleTypeById: {},
    error: '',
};

export const fetchFTVehicleTypes = createAsyncThunk(
    'ftVehicleTypes/fetchFTVehicleTypes',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/machinetype`, { params });
            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const fetchFTVehicleTypeById = createAsyncThunk(
    'ftVehicleTypes/fetchFTVehicleTypeById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/machinetype/${id}`);
            return response.data.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const createFTVehicleType = createAsyncThunk(
    'ftVehicleTypes/createFTVehicleType',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_HOST_API_KEY}/machinetype`, data);
            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const updateFTVehicleType = createAsyncThunk(
    'ftVehicleTypes/updateFTVehicleType',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_HOST_API_KEY}/machinetype`, data);
            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const deleteFTVehicleType = createAsyncThunk(
    'ftVehicleTypes/deleteFTVehicleType',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_HOST_API_KEY}/machinetype`, { data });
            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

const ftVehicleTypesSlice = createSlice({
    name: 'ftVehicleTypesSlice',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchFTVehicleTypes.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTVehicleTypes.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.vehicleTypes = payload.data;
        });
        builder.addCase(fetchFTVehicleTypes.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(fetchFTVehicleTypeById.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTVehicleTypeById.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.vehicleTypeById = payload;
        });
        builder.addCase(fetchFTVehicleTypeById.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(createFTVehicleType.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(createFTVehicleType.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(createFTVehicleType.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(updateFTVehicleType.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateFTVehicleType.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(updateFTVehicleType.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(deleteFTVehicleType.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(deleteFTVehicleType.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(deleteFTVehicleType.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default ftVehicleTypesSlice.reducer;

export const selectFTVehicleTypesData = (state) => state.ftVehicleTypes.vehicleTypes;
export const selectFTVehicleTypeById = (state) => state.ftVehicleTypes.vehicleTypeById;
export const selectFTVehicleTypesLoading = (state) => state.ftVehicleTypes.isLoading;
export const selectFTVehicleTypesError = (state) => state.ftVehicleTypes.error;
